const updateFilters = filters => dispatch => {
  dispatch({
    type: "UPDATE_FILTERS",
    payload: filters
  });
};

export default updateFilters;



// WEBPACK FOOTER //
// ./src/actions/filters.js